export const maxItems = 50
export const maxAssetsInItem = 100
